import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getTabs = createAsyncThunk('tabs', async () => {
  const url = `${URL}/tabs`;
  const response = await apiConfig.get(url).catch((error) => {
    console.error(JSON.stringify(error));
    return error?.response;
  });

  response.data.details.sort((a, b) => a.defaultPriority - b.defaultPriority);
  return response.data;
});

export const getTabDetails = createAsyncThunk('tabs/{tabId}', async (tabId) => {
  const url = `${URL}/tabs/${tabId}`;
  const response = await apiConfig.get(url).catch((error) => {
    console.error(JSON.stringify(error));
    return error?.response;
  });

  return response.data;
});

export const updateTab = createAsyncThunk(
  'tabs/{tabId}/update',
  async (payload) => {
    const url = `${URL}/tabs/${payload.id}`;
    const response = await apiConfig.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error?.response;
    });

    return response.data;
  },
);

export const addNewTab = createAsyncThunk(
  'tabs/{tabId}/addNew',
  async (payload, { getState }) => {
    // Check if a tab with this code already exists
    const existingTabs = getState().paymentOptions.tabs.tabList;
    const duplicateTab = existingTabs.find((tab) => tab.code === payload.code);

    if (duplicateTab) {
      throw new Error('A tab with this code already exists');
    }

    const url = `${URL}/tabs`;
    const response = await apiConfig.post(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error?.response;
    });

    return response.data;
  },
);

const paymentOptionsTabsSlice = createSlice({
  name: 'paymentOptionsTabs',
  initialState: {
    tabList: [],
    selectedTab: {},
  },
  reducers: {
    resetTabs(state) {
      state.tabList = [];
    },
    resetSelectedTab(state) {
      state.selectedTab = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTabs.fulfilled, (state, action) => {
        if (!action.payload?.details) {
          state.tabList = [];
          return;
        }
        state.tabList = action.payload.details;
      })
      .addCase(getTabDetails.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          state.selectedTab = {};
          return;
        }
        state.selectedTab = action.payload;
      })
      .addCase(addNewTab.fulfilled, (state, action) => {
        if (action.payload?.status === 'SUCCESS') {
          state.selectedTab = {};
        }
      })
      .addCase(updateTab.fulfilled, (state, action) => {
        if (action.payload?.status === 'SUCCESS') {
          state.selectedTab = {};
        }
      });
  },
});

export const selectTabList = (state) => state.paymentOptions.tabs.tabList;

export const selectTabsDefaultPriority = createSelector(selectTabList, (tabs) =>
  tabs.map((tab) => ({
    ...tab,
    priority: tab.defaultPriority,
  })),
);

export const selectSelectedTab = (state) =>
  state.paymentOptions.tabs.selectedTab;

export const paymentOptionsTabsActions = paymentOptionsTabsSlice.actions;

export default paymentOptionsTabsSlice.reducer;
